import axios from 'axios';
import { API_HOST } from '../index';
var guestClient = axios.create({
    baseURL: API_HOST,
    timeout: 30000
});
guestClient.interceptors.request.use(function (request) {
    return request;
}, function (error) { return Promise.reject(error); });
guestClient.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error && error.response) {
        return Promise.reject(error.response.data);
    }
    else {
        return Promise.reject(error);
    }
});
export default guestClient;
